<template>
  <div class="profileBox">
    <div class="userBox" v-if="profilePage">
<!--      <div class="userImage">-->
<!--        <div class="img"></div>-->
<!--        <p class="txt">프로필 이미지는 멤버와 모든 고객에게 노출됩니다.</p>-->
<!--      </div>-->
      <v-form ref="form" v-model="valid">
        <div class="userData">
          <dl>
            <dt class="required require-before">必須情報</dt>
            <dt class="require-after">名前</dt>
            <dd>
              <v-text-field
                v-model="agentInfo.name"
                placeholder="ex) 山田 太郎"
                class="UXinput UXicon-edit"
                :rules="[rules.required, rules.nameMax]"
                outline
                solo
              >
              </v-text-field>
              <div class="exampleText" style="margin-top: 10px; color: gray; font-size: 10pt;">
                例）山田 太郎
              </div>
            </dd>
            <dt class="require-after">名前 (フリガナ)</dt>
            <dd>
              <v-text-field
                v-model="agentInfo.nameKana"
                placeholder="ex) ヤマダ タロウ"
                class="UXinput UXicon-edit"
                :rules="[rules.required, rules.nameKanaMax, rules.nameKana]"
                outline
                solo
              >
              </v-text-field>
              <div style="margin-top: 10px; color: gray; font-size: 10pt;">
                例）ヤマダ タロウ
              </div>
            </dd>
            <dt>ID</dt>
            <dd>
              <v-text-field
                v-model="agentInfo.loginId"
                placeholder="英文, 数字を組み合わせて6桁以上"
                class="UXinput UXicon-edit"
                disabled
                hide-details
                outline
                solo
              >
              </v-text-field>
            </dd>
            <dt class="require-after">メールアドレス</dt>
            <dd>
              <v-text-field
                v-model="agentInfo.email"
                placeholder="twcjapan@thewc.co.jp"
                class="UXinput UXicon-edit"
                :rules="[rules.required, rules.emailRules]"
                outline
                solo
              >
              </v-text-field>
              <div style="margin-top: 10px; color: gray; font-size: 10pt;">
                例）twcjapan@thewc.co.jp
              </div>
            </dd>
            <dt class="require-after">携帯番号</dt>
            <dd>
              <v-text-field
                v-model="agentInfo.phoneNumber"
                placeholder="ex) 09012345678"
                class="UXinput UXicon-edit"
                :rules="[rules.required, rules.phoneNumberValidate, rules.phoneMax]"
                outline
                solo
              >
              </v-text-field>
              <div style="margin-top: 10px; color: gray; font-size: 10pt;">
                例）09012345678
              </div>
            </dd>
          </dl>
        </div>
      </v-form>
      <div class="chagePage">
        <a class="next" @click="profilePage = false">
          <div class="pwd">
            <i class="UXicon-password"></i>パスワードを変更する
          </div>
        </a>
      </div>
      <div class="cenBtn">
        <v-btn round large outline class="UXbtn widthAuto" @click="close">キャンセル</v-btn>
        <v-btn round dark large color="#FF8C8C" class="UXbtn widthAuto" @click="setAgentInfo" :disabled="!valid">確認</v-btn>
      </div>
    </div>
    <div class="userBox" v-else>
      <div class="userData">
        <div class="chagePage">
          <a class="prev" @click="profilePage = true">
            <i class="UXicon-return"></i> 戻る
          </a>
        </div>
        <dl>
          <dt>現在のパスワード</dt>
          <dd>
            <v-text-field
              placeholder="現在のパスワードを入力してください"
              class="UXinput iconBtn noErrorType"
              hide-details
              outline
              solo
              v-model="agentInfo.password"
              :append-icon="pwShow ? 'visibility_off' : 'visibility'"
              :rules="[rules.passwordValidate]"
              :type="pwShow ? 'text' : 'password'"
              @click:append="pwShow = !pwShow"
            ></v-text-field>
          </dd>
          <dt>新しいパスワード</dt>
          <dd>
            <v-text-field
              placeholder="新しいパスワードを入力してください"
              class="UXinput iconBtn noErrorType"
              hide-details
              outline
              solo
              v-model="agentInfo.newPassword"
              :rules="[rules.passwordValidate]"
              :append-icon="newPwShow ? 'visibility_off' : 'visibility'"
              :type="newPwShow ? 'text' : 'password'"
              @click:append="newPwShow = !newPwShow"
            ></v-text-field>
            <p class="sTxt">半角英数字と特殊文字を組み合わせた8文字以上15文字以下</p>
          </dd>
          <dt>新しいパスワードの確認</dt>
          <dd>
            <v-text-field
              placeholder="新しいパスワードを入力してください"
              class="UXinput iconBtn noErrorType"
              hide-details
              outline
              solo
              v-model="agentInfo.retryNewPassword"
              :rules="[rules.passwordValidate]"
              :append-icon="retryPwShow ? 'visibility_off' : 'visibility'"
              :type="retryPwShow ? 'text' : 'password'"
              @click:append="retryPwShow = !retryPwShow"
            ></v-text-field>
          </dd>
        </dl>
      </div>
      <div class="cenBtn">
        <v-btn round large outline class="UXbtn widthAuto" @click="close">キャンセル</v-btn>
        <v-btn round dark large color="#FF8C8C" class="UXbtn widthAuto" @click="setPassword">確認</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'new_user_info',
  props: ['controlStatus'],
  data () {
    return {
      info: false,
      pwShow: false,
      newPwShow: false,
      retryPwShow: false,
      profilePage: true,
      rules: {
        min: v => v.length >= 6 || '6文字以上で入力してください。',
        passwordValidate: v => {
          if (v) {
            return /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/g.test(v) || '半角英数字と特殊文字を組み合わせた8文字以上15文字以下'
          } else {
            return false
          }
        },
        emailRules: v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/g.test(v) || 'メールアドレスの形式が正しくありません。',
        phoneNumberValidate: v => /^[0-9]+$/g.test(v) || '数字のみ入力できます。',
        phoneMax: v => (v && v.length <= 13) || '13文字まで入力可能です。',
        nameMax: v => (v && v.length <= 20) || '最大20文字まで入力可能.',
        nameKana: v => /^[ァ-ヶーｦ-ﾟ\s]+$/g.test(v) || 'カタカナとスペースのみ入力できます。',
        nameKanaMax: v => (v && v.length <= 20) || '最大20文字まで入力可能.',
        required: value => !!value || '入力情報がありません。'
      },
      agentInfo: {
        name: '',
        nameKana: '',
        loginId: '',
        phoneNumber: '',
        email: '',
        password: '',
        newPassword: '',
        retryNewPassword: ''
      },
      valid: false
    }
  },
  computed: {
    ...mapGetters(['agentMappingBrandViews', 'currentBrandId', 'callMode'])
  },
  watch: {
    controlStatus (val) {
      if (val === 'PROFILE' && !this.info) {
        this.loadAgentInfo()
      } else {
        this.setData(this.info)
        this.profilePage = true
      }
    }
  },
  methods: {
    ...mapMutations([
      'changeName',
      'CLOSE_CALL'
    ]),
    close () {
      this.$eventBus.$emit('closeUserLayer')
    },
    setData (info) {
      this.agentInfo.name = info.name
      this.agentInfo.nameKana = info.nameKana
      this.agentInfo.email = info.email
      this.agentInfo.phoneNumber = info.phoneNumber
      this.agentInfo.loginId = info.loginId
      this.agentInfo.image = info.image

      this.agentInfo.password = ''
      this.agentInfo.newPassword = ''
      this.agentInfo.retryNewPassword = ''
    },
    loadAgentInfo () {
      this.$http({
        method: 'GET',
        url: '/api/agent/edit'
      }).then((res) => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$toasted.error(res.data.message || res.statusText)
          return
        }
        this.info = res.data.data
        this.setData(res.data.data)
      })
    },
    setAgentInfo () {
      let param = {}
      if (!this.agentInfo.name && !this.agentInfo.nameKana) {
        this.$toasted.error('名前を入力してください。')
        return false
      } else {
        param['name'] = this.agentInfo.name
        param['nameKana'] = this.agentInfo.nameKana
      }
      Object.keys(this.agentInfo).forEach((k) => {
        if ((k === 'phoneNumber' || k === 'email' || k === 'agentImage') && this.agentInfo[k]) {
          param[k] = this.agentInfo[k]
        }
      })

      this.callModuleCheck()

      this.$http({
        method: 'POST',
        url: '/api/agent/edit/info',
        data: param
      }).then((res) => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$toasted.error(res.data.message || res.statusText)
          return
        }
        this.$toasted.success('変更された情報は再ログイン時に反映されます')
        this.info = false
        this.close()
      }).catch((e) => {
        this.$toasted.error(e)
      })
    },
    callModuleCheck () {
      let brandId = this.currentBrandId || this.agentMappingBrandViews.sort((s1, s2) => s1.brandId - s2.brandId)[0].brandId
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: brandId,
          moduleName: 'CALL',
          channelName: this.callMode === 'KT' ? 'KT_CALL' : 'CALL'
        }
      }).then(result => {
        if (result.data.code === 0 && this.callMode !== 'KT') {
          this.modifyCallAgent()
        }
      }).catch(err => {
        this.$toasted.error(err.message)
      })
    },
    modifyCallAgent () {
      if (this.agentInfo.loginId) {
        this.axios.post('/gateway/call/agent/modify', {
          externalId: this.agentInfo.loginId,
          talkLoginId: this.agentInfo.loginId,
          userNm: this.agentInfo.name
        })
      }
    },
    setPassword () {
      if (!this.agentInfo.password || !this.agentInfo.newPassword || !this.agentInfo.retryNewPassword) {
        this.$toasted.error('パスワードを入力してください。')
        return false
      }
      if (this.agentInfo.newPassword !== this.agentInfo.retryNewPassword) {
        this.$toasted.error('パスワードが一致しません。')
        return false
      }
      this.$http({
        method: 'POST',
        url: '/api/agent/edit/password',
        data: {
          password: this.agentInfo.password,
          newPassword: this.agentInfo.newPassword,
          retryNewPassword: this.agentInfo.retryNewPassword
        }
      }).then((res) => {
        if (res.status !== 200 || res.data.code !== 0) {
          this.$toasted.error(res.data.message || res.statusText)
          return
        }
        this.$toasted.success('変更された情報は再ログイン時に反映されます')
        this.close()
      }).catch((e) => {
        this.$toasted.error(e)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/header/fragments/new_user_info.vue